/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SupportInputs */

const en_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const es_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Nav_SupportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_support = /** @type {((inputs?: Nav_SupportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SupportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_support(inputs)
	return es_nav_support(inputs)
});